/* maamii – Interaktionen V2 (2026) */
(function () {
  'use strict';
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Farben: Varianten-Namen aus dem Shop → Schlüssel + Farbe */
  var COLORS = {
    beige: { hex: '#D9C8B1', tint: '#F4EFE7', name: 'Beige' },
    rose:  { hex: '#CBA7A0', tint: '#FAF1EF', name: 'Rosa' },
    pink:  { hex: '#BD747B', tint: '#F9E9EB', name: 'Pink' },
    olive: { hex: '#9BAD6C', tint: '#F1F4E7', name: 'Olive' },
    blue:  { hex: '#8097A6', tint: '#ECF1F5', name: 'Blau' },
    gelb:  { hex: '#E3B04F', tint: '#FBF3E2', name: 'Gelb' }
  };
  var MAT = { beige: '#E9DBC6', rose: '#E4C8C1', pink: '#D6A1A5', olive: '#BAC69F', blue: '#BFD3DA', gelb: '#D9B055' };
  var ORDER = ['beige', 'rose', 'pink', 'olive', 'blue', 'gelb'];
  function colorKey(name) {
    var n = String(name || '').toLowerCase().trim();
    if (/beige|sand|creme|elfenbein|nude/.test(n)) return 'beige';
    if (/rosa|rose|altrosa|peach/.test(n)) return 'rose';
    if (/pink|dusty/.test(n)) return 'pink';
    if (/olive|sage|grün|gruen|green|salbei/.test(n)) return 'olive';
    if (/blau|blue|bleu|azzurro/.test(n)) return 'blue';
    if (/gelb|yellow|senf/.test(n)) return 'gelb';
    return null;
  }
  function readJSON(el, attr) { try { return JSON.parse(el.getAttribute(attr)); } catch (e) { return null; } }
  function variantsByKey(product) {
    var map = {};
    (product && product.v || []).forEach(function (v) {
      var k = colorKey(v.c);
      if (k && (!map[k] || (!map[k].a && v.a))) map[k] = v;
    });
    return map;
  }

  /* Warenkorb: wie das Theme (Drawer öffnet sich), sonst Weiterleitung */
  function toast(msg) {
    var t = document.createElement('div'); t.className = 'mm-toast'; t.setAttribute('role', 'status'); t.textContent = msg;
    document.body.appendChild(t); setTimeout(function () { t.remove(); }, 2400);
  }
  function addToCart(form) {
    var btn = form.querySelector('[type="submit"]');
    var cart = document.querySelector('cart-drawer');
    var fd = new FormData(form);
    if (cart && cart.getSectionsToRender) {
      fd.append('sections', cart.getSectionsToRender().map(function (s) { return s.id; }));
      fd.append('sections_url', window.location.pathname);
    }
    if (btn) btn.classList.add('is-loading');
    fetch((window.routes && window.routes.cart_add_url) || '/cart/add', { method: 'POST', headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/javascript' }, body: fd })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res.status) { toast(res.description || 'Leider nicht mehr verfügbar.'); return; }
        if (cart && cart.renderContents) { cart.renderContents(res); }
        else { window.location.href = (window.routes && window.routes.cart_url) || '/cart'; }
      })
      .catch(function () { form.submit(); })
      .finally(function () { if (btn) btn.classList.remove('is-loading'); });
  }
  document.addEventListener('submit', function (e) {
    var f = e.target.closest && e.target.closest('form[data-mm-add]');
    if (!f) return; e.preventDefault(); addToCart(f);
  });

  /* Produktkarten mit Farbpunkten */
  function initCard(card) {
    if (card.dataset.mmReady) return; card.dataset.mmReady = '1';
    var p = readJSON(card, 'data-mm-product'); if (!p) return;
    var byKey = variantsByKey(p);
    var keys = ORDER.filter(function (k) { return byKey[k]; });
    var dots = $('[data-mm-dots]', card), img = $('[data-mm-img]', card), vid = $('[data-mm-vid]', card), price = $('[data-mm-price]', card), media = $('.mm-card__media', card);
    card.mmSet = function (k) {
      if (!byKey[k]) k = keys[0]; if (!k) return;
      var v = byKey[k];
      if (img && v.img) img.src = v.img;
      if (vid) vid.value = v.id;
      if (price && v.p) price.textContent = v.p;
      if (media) media.style.setProperty('--mm-tint', COLORS[k].tint);
      $$('button', dots).forEach(function (b) { b.setAttribute('aria-pressed', b.dataset.k === k ? 'true' : 'false'); });
    };
    card.mmKeys = keys;
    keys.forEach(function (k) {
      var b = document.createElement('button'); b.type = 'button'; b.dataset.k = k; b.style.background = COLORS[k].hex;
      b.setAttribute('aria-label', COLORS[k].name); b.setAttribute('aria-pressed', 'false');
      b.addEventListener('click', function () { card.mmSet(k); });
      dots.appendChild(b);
    });
  }
  var MIX = ['pink', 'olive', 'blue', 'rose', 'beige', 'pink', 'blue', 'olive', 'rose', 'beige', 'olive', 'pink'];
  function initColorSection(sec) {
    if (sec.dataset.mmReady) return; sec.dataset.mmReady = '1';
    var cards = $$('[data-mm-card]', sec); cards.forEach(initCard);
    function apply(k) {
      cards.forEach(function (c, i) { if (c.mmSet) c.mmSet(k === 'mix' ? MIX[i % MIX.length] : k); });
      $$('[data-mm-pal]', sec).forEach(function (b) { var on = b.dataset.mmPal === k; b.classList.toggle('is-active', on); b.setAttribute('aria-pressed', on ? 'true' : 'false'); });
    }
    $$('[data-mm-pal]', sec).forEach(function (b) { b.addEventListener('click', function () { apply(b.dataset.mmPal); }); });
    apply('mix');
  }

  /* Tabs (Phasen) */
  function initTabs(root) {
    if (root.dataset.mmReady) return; root.dataset.mmReady = '1';
    var tabs = $$('[data-mm-tab]', root), panels = $$('[data-mm-panel]', root);
    function show(i) {
      tabs.forEach(function (t, n) { t.setAttribute('aria-selected', n === i ? 'true' : 'false'); t.tabIndex = n === i ? 0 : -1; });
      panels.forEach(function (p, n) { p.hidden = n !== i; });
    }
    tabs.forEach(function (t, i) {
      t.addEventListener('click', function () { show(i); });
      t.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') { var n = (i + (e.key === 'ArrowRight' ? 1 : tabs.length - 1)) % tabs.length; show(n); tabs[n].focus(); }
      });
    });
    show(0);
  }

  /* Farbtupfer (grosse Swatches) */
  function buildSwatches(box, keys, onPick, hexMap) {
    box.innerHTML = '';
    keys.forEach(function (k) {
      var b = document.createElement('button'); b.type = 'button'; b.dataset.k = k;
      b.style.background = (hexMap || {})[k] || COLORS[k].hex;
      b.setAttribute('aria-label', COLORS[k].name); b.setAttribute('aria-pressed', 'false');
      b.addEventListener('click', function () { onPick(k, true); });
      box.appendChild(b);
    });
    return function mark(k) { $$('button', box).forEach(function (b) { b.setAttribute('aria-pressed', b.dataset.k === k ? 'true' : 'false'); }); };
  }
  function setBuy(root, v) {
    if (!v) return;
    var vid = $('[data-mm-vid]', root), price = $('[data-mm-price]', root);
    if (vid) vid.value = v.id; if (price && v.p) price.textContent = v.p;
  }

  /* Dino */
  function initDino(sec) {
    if (sec.dataset.mmReady) return; sec.dataset.mmReady = '1';
    var imgs = readJSON(sec, 'data-imgs') || {}; var p = readJSON(sec, 'data-mm-product');
    var byKey = variantsByKey(p);
    var keys = ['beige', 'rose', 'pink', 'olive', 'blue'].filter(function (k) { return imgs[k] && (!p || byKey[k]); });
    var img = $('[data-mm-dino-img]', sec);
    var mark = buildSwatches($('[data-mm-swatches]', sec), keys, pick);
    function pick(k) {
      if (img && imgs[k]) { img.style.opacity = 0; setTimeout(function () { img.src = imgs[k]; img.alt = 'Dino Divide Teller in ' + COLORS[k].name; img.style.opacity = 1; }, 150); }
      sec.style.setProperty('--mm-tint', COLORS[k].tint); mark(k); setBuy(sec, byKey[k]);
    }
    pick(keys.indexOf(sec.dataset.start) >= 0 ? sec.dataset.start : keys[0]);
  }

  /* Sip 'n' Snack */
  function initSip(sec) {
    if (sec.dataset.mmReady) return; sec.dataset.mmReady = '1';
    var imgs = readJSON(sec, 'data-imgs') || {}; var p = readJSON(sec, 'data-mm-product');
    var byKey = variantsByKey(p);
    var keys = ['beige', 'rose', 'pink', 'olive', 'blue'].filter(function (k) { return imgs[k] && (!p || byKey[k]); });
    var stage = $('[data-mm-sip-stage]', sec), bubble = $('[data-mm-sip-bubble]', sec);
    var steps = $$('[data-mm-mode]', sec), dots = $$('.mm-sip__dots i', sec);
    var mode = 0, color = keys[0], locked = false;
    function render() {
      var set = imgs[color] || {};
      $$('[data-l]', stage).forEach(function (el) { var u = set[el.dataset.l]; if (u) el.src = u; });
      stage.className = 'mm-sip__stage is-m' + mode + (mode === 0 && set.photo ? ' is-photo' : '');
      steps.forEach(function (s, i) { var on = i === mode; s.classList.toggle('is-active', on); s.setAttribute('aria-selected', on ? 'true' : 'false'); });
      dots.forEach(function (d, i) { d.classList.toggle('is-on', i === mode); });
      if (bubble && steps[mode]) bubble.textContent = steps[mode].dataset.bubble;
    }
    var mark = buildSwatches($('[data-mm-swatches]', sec), keys, function (k) { color = k; mark(k); setBuy(sec, byKey[k]); render(); });
    steps.forEach(function (s, i) { s.addEventListener('click', function () { locked = true; mode = i; render(); }); });
    mark(color); setBuy(sec, byKey[color]); render();
    if (!reduce) setInterval(function () { if (!locked && !document.hidden) { mode = (mode + 1) % 3; render(); } }, 3500);
  }

  /* Montessori */
  var COMBO = { beige: [2, 3], rose: [3, 0], pink: [0, 3], olive: [2, 0], blue: [0, 2], gelb: [4, 2] };
  function initMont(sec) {
    if (sec.dataset.mmReady) return; sec.dataset.mmReady = '1';
    var mats = readJSON(sec, 'data-mats') || {}, plates = readJSON(sec, 'data-plates') || [], bowls = readJSON(sec, 'data-bowls') || [];
    var p = readJSON(sec, 'data-mm-product'); var byKey = variantsByKey(p);
    var keys = ORDER.filter(function (k) { return mats[k] && (!p || byKey[k]); });
    var box = $('.mm-mo__box', sec), mat = $('[data-mm-mat]', sec), plate = $('[data-mm-plate]', sec), bowl = $('[data-mm-bowl]', sec);
    var steps = $$('[data-mm-step]', sec), step = 3, locked = false;
    function showStep(i) {
      step = i; box.className = 'mm-mo__box is-s' + i;
      steps.forEach(function (s, n) { var on = n === i; s.classList.toggle('is-active', on); s.setAttribute('aria-selected', on ? 'true' : 'false'); });
    }
    var mark = buildSwatches($('[data-mm-swatches]', sec), keys, function (k) {
      mark(k); setBuy(sec, byKey[k]);
      if (mats[k]) mat.src = mats[k];
      var c = COMBO[k] || [2, 3]; if (plates[c[0]]) plate.src = plates[c[0]]; if (bowls[c[1]]) bowl.src = bowls[c[1]];
    }, MAT);
    steps.forEach(function (s, i) { s.addEventListener('click', function () { locked = true; showStep(i); }); });
    var start = keys.indexOf(sec.dataset.start) >= 0 ? sec.dataset.start : keys[0];
    var b0 = $('[data-mm-swatches] button[data-k="' + start + '"]', sec); if (b0) b0.click();
    showStep(3);
    if (!reduce) setInterval(function () { if (!locked && !document.hidden) showStep((step + 1) % 4); }, 3500);
  }

  /* Situationen: auf Touch-Geräten per Tipp öffnen */
  function initSit(card) {
    if (card.dataset.mmReady) return; card.dataset.mmReady = '1';
    card.addEventListener('click', function (e) {
      if (window.matchMedia('(hover: hover)').matches) return;
      if (!card.classList.contains('is-open')) { e.preventDefault(); $$('[data-mm-sit].is-open').forEach(function (c) { c.classList.remove('is-open'); }); card.classList.add('is-open'); }
    });
  }

  /* Teilen: Link kopieren */
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-mm-copy]'); if (!b) return;
    var url = b.getAttribute('data-mm-copy');
    if (navigator.share && window.matchMedia('(hover: none)').matches) { navigator.share({ url: url }).catch(function () {}); return; }
    (navigator.clipboard ? navigator.clipboard.writeText(url) : Promise.reject()).then(function () { toast('Link kopiert'); }).catch(function () { window.prompt('Link kopieren:', url); });
  });

  /* Gratis Vorlagen: nach Anmeldung offen lassen */
  function initFree(sec) {
    if (sec.dataset.mmReady) return; sec.dataset.mmReady = '1';
    var open = $('[data-mm-free-open]', sec), locked = $('[data-mm-free-locked]', sec);
    var key = 'mm_vorlagen_frei';
    try {
      if (open && !open.hidden) localStorage.setItem(key, '1');
      else if (localStorage.getItem(key) === '1' && open && locked) { open.hidden = false; locked.hidden = true; }
    } catch (e) {}
  }

  function initAnnouncement(root) {
    if (root.dataset.mmReady) return; root.dataset.mmReady = '1';
    var msgs = $$('.mm-ann__msg', root); if (msgs.length < 2) return;
    var i = 0, interval = parseInt(root.getAttribute('data-interval'), 10) || 4000, paused = false;
    function setFocusable(el, on) { $$('a', el).forEach(function (a) { if (on) a.removeAttribute('tabindex'); else a.setAttribute('tabindex', '-1'); }); }
    msgs.forEach(function (m, n) { setFocusable(m, n === 0); });
    function show(n) {
      msgs[i].classList.remove('is-active'); msgs[i].setAttribute('aria-hidden', 'true'); setFocusable(msgs[i], false);
      i = (n + msgs.length) % msgs.length;
      msgs[i].classList.add('is-active'); msgs[i].removeAttribute('aria-hidden'); setFocusable(msgs[i], true);
    }
    ['mouseenter', 'focusin'].forEach(function (ev) { root.addEventListener(ev, function () { paused = true; }); });
    ['mouseleave', 'focusout'].forEach(function (ev) { root.addEventListener(ev, function () { paused = false; }); });
    setInterval(function () { if (!paused && !document.hidden) show(i + 1); }, interval);
  }

  function initAll(scope) {
    var s = scope || document;
    $$('[data-mm-ann]', s).forEach(initAnnouncement);
    $$('[data-mm-colors]', s).forEach(initColorSection);
    $$('[data-mm-card]', s).forEach(initCard);
    $$('[data-mm-tabs]', s).forEach(initTabs);
    $$('[data-mm-dino]', s).forEach(initDino);
    $$('[data-mm-sip]', s).forEach(initSip);
    $$('[data-mm-mont]', s).forEach(initMont);
    $$('[data-mm-sit]', s).forEach(initSit);
    $$('[data-mm-free]', s).forEach(initFree);
  }
  window.mmInit = initAll;
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); });
  else initAll();
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
